import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { Breadcrumb, Form, message } from 'antd';

import text from './UserControl.page.translation';

import FormUserControl from './UserControl.form.component';

const UserControlForm = Form.create()(FormUserControl);

export default class UserControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formControlSubmit: {
        isFetching: false,
      },
    };
    this.success = this.success.bind(this);
  }

  handleSubmit = submitParams => {
    this.setState(prev => ({
      formControlSubmit: { ...prev.formControlSubmit, isFetching: true },
    }));
    this.props.changePassword(
      submitParams,
      this.success.bind(this),
      this.callbackError.bind(this),
    );
  };

  success() {
    this.setState({ formControlSubmit: { isFetching: false } });
    this._messageAlert(
      'success',
      this.props.intl.formatMessage(text.alertSuccess),
    );
  }

  callbackError(val) {
    const {
      intl: { formatMessage },
    } = this.props;
    if (val === 1) {
      this._messageAlert('error', formatMessage(text.alertFailed));
    } else {
      this._messageAlert('error', formatMessage({ id: 'error' }));
    }

    this.setState({ formControlSubmit: { isFetching: false } });
  }

  _messageAlert = (type, val) => {
    if (type === 'success') {
      message.success(val);
    } else if (type === 'error') {
      message.error(val);
    }
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">{formatMessage(text.home)}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{formatMessage(text.page)}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <span className="title" style={{ marginBottom: '30px' }}>
            {formatMessage(text.title)}
          </span>

          <div id="form-change-password">
            <UserControlForm
              onSubmit={this.handleSubmit}
              intl={this.props.intl}
              isFetching={this.state.formControlSubmit.isFetching}
            />
          </div>
        </div>
      </div>
    );
  }
}

UserControl.propTypes = {
  changePassword: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};
